import { gql } from "@apollo/client";

export const GET_METRICS_EXPLORER_SAVED_VIEWS = gql`
  query GetMetricsExplorerSavedViews {
    me {
      id
      metricsExplorerSavedViews
    }
  }
`;

export const CREATE_METRICS_EXPLORER_SAVED_VIEW = gql`
  mutation CreateMetricsExplorerSavedView(
    $name: String!
    $config: JSONObject!
  ) {
    createMetricsExplorerSavedView(name: $name, config: $config)
  }
`;

export const UPDATE_METRICS_EXPLORER_SAVED_VIEW = gql`
  mutation UpdateMetricsExplorerSavedView(
    $id: Int!
    $name: String
    $config: JSONObject
  ) {
    updateMetricsExplorerSavedView(id: $id, name: $name, config: $config)
  }
`;

export const UPDATE_METRICS_EXPLORER_SAVED_VIEW_ORDERING_TO_ALL_ACCOUNT_MANAGERS = gql`
  mutation UpdateMetricsExplorerSavedViewOrderingToAllAccountManagers(
    $ids: [Int!]!
  ) {
    updateMetricsExplorerSavedViewOrderingToAllAccountManagers(ids: $ids)
  }
`;

export const UPDATE_METRICS_EXPLORER_SAVED_VIEW_ORDERING = gql`
  mutation UpdateMetricsExplorerSavedViewOrdering($ids: [Int!]!) {
    updateMetricsExplorerSavedViewOrdering(ids: $ids)
  }
`;

export const CREATE_HIDDEN_METRICS_EXPLORER_SAVED_VIEW_TEMPLATE = gql`
  mutation CreateHiddenMetricsExplorerSavedViewTemplate($id: Int!) {
    createClientHiddenMetricsExplorerSavedViewTemplate(id: $id)
  }
`;

export const DELETE_METRICS_EXPLORER_SAVED_VIEW = gql`
  mutation DeleteMetricsExplorerSavedView($id: Int!) {
    deleteMetricsExplorerSavedView(id: $id)
  }
`;
